export const MAX_EPISODE_TITLE_LENGTH = 100;
export const UP_EPISODE_TIME = 2 * 24 * 60 * 60 * 1000;

export enum EpisodeOrderType {
  LatestCreatedAt = 'LatestCreatedAt',
  LatestUpdatedAt = 'LatestUpdatedAt',
  LatestFirstOpenedAt = 'LatestFirstOpenedAt',
  LastVolume = 'LastVolume',
  LastOrder = 'LastOrder',
  FirstVolume = 'FirstVolume',
  FirstOrder = 'FirstOrder',
  None = 'None',
}

export enum EpisodeIncludeMediaType {
  Image = 'Image',
  Video = 'Video',
}

export const EpisodeIncludeMediaTypeString = {
  [EpisodeIncludeMediaType.Image]: '이미지',
  [EpisodeIncludeMediaType.Video]: '비디오',
};

export enum EpisodeStatus {
  Private = 'Private',
  Public = 'Public',
  Reserved = 'Reserved',
  Deleted = 'Deleted',
}

export const EpisodeStatusString = {
  [EpisodeStatus.Private]: '비공개',
  [EpisodeStatus.Public]: '공개',
  [EpisodeStatus.Reserved]: '공개예약',
  [EpisodeStatus.Deleted]: '삭제됨',
};

export enum EpisodeFilePrefix {
  Episode = 'episodes/files/',
  EpisodeInclude = 'episodes/include-files/',
}
